const { colors } = require('../colors/index');

const yuhu = {
  '@primary-6': 'red',
  '@border-color-split': colors.neutral[5],
  '@btn-text-hover-bg': 'transparent',
};

module.exports = yuhu;
